(function () {
  'use strict';

  if (window.__BigsmallAiSearchBridge) return;
  window.__BigsmallAiSearchBridge = true;

  var FINDER_PATH = '/pages/ai-gift-finder';
  var FEW_RESULTS_MAX = 3;
  var seenViews = {};

  var BRIEF_SIGNALS = [
    /\b(under|below|within|upto|up to|budget|around|approx)\b/i,
    /(?:₹|rs\.?|inr)\s?\d/i,
    /\b\d[\d,]*\s*(?:k|pcs|pieces|units|nos|employees?|people|persons?|clients?|members|joiners?)\b/i,
    /\b(?:for|to)\s+(?:my|our|the|new|all)?\s*(?:employees?|clients?|team|staff|customers?|joiners?|partners?|vendors?)\b/i,
    /\b(?:without|excluding|exclude)\b/i
  ];

  function finderUrl(query, from) {
    var value = String(query || '').trim();
    var params = [];
    if (value) params.push('q=' + encodeURIComponent(value));
    if (from) params.push('from=' + encodeURIComponent(from));
    return FINDER_PATH + (params.length ? '?' + params.join('&') : '');
  }

  function wordCount(value) {
    var matches = String(value || '').match(/[A-Za-z0-9\u00C0-\u024F]+/g);
    return matches ? matches.length : 0;
  }

  // A "brief" is a sentence-like requirement (budget, quantity, recipient,
  // exclusions), not a product name or a short category search.
  function looksLikeBrief(query) {
    var value = String(query || '').trim();
    var words = wordCount(value);
    if (words < 3) return false;
    if (words >= 7) return true;
    return BRIEF_SIGNALS.some(function (pattern) { return pattern.test(value); });
  }

  // Sends to GA4 (gtag) when present, otherwise the dataLayer, and also to
  // Shopify customer events so a custom pixel can pick it up.
  function track(name, params) {
    params = params || {};
    try {
      if (typeof window.gtag === 'function') {
        var withTransport = { transport_type: 'beacon' };
        Object.keys(params).forEach(function (key) { withTransport[key] = params[key]; });
        window.gtag('event', name, withTransport);
      } else {
        window.dataLayer = window.dataLayer || [];
        var item = { event: name };
        Object.keys(params).forEach(function (key) { item[key] = params[key]; });
        window.dataLayer.push(item);
      }
    } catch (error) { /* tracking must never break search */ }
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, params);
      }
    } catch (error) { /* ignore */ }
  }

  function trackView(context, reason, query, count) {
    var key = context + '|' + reason;
    if (seenViews[key]) return;
    seenViews[key] = true;
    track('ai_finder_prompt_view', {
      prompt_context: context,
      prompt_reason: reason,
      search_term: String(query || '').trim().slice(0, 80),
      results_count: count
    });
  }

  function trackClick(context, reason, query, count) {
    track('ai_finder_prompt_click', {
      prompt_context: context,
      prompt_reason: reason,
      search_term: String(query || '').trim().slice(0, 80),
      results_count: count
    });
  }

  window.BigsmallAiFinder = {
    FEW_RESULTS_MAX: FEW_RESULTS_MAX,
    looksLikeBrief: looksLikeBrief,
    finderUrl: finderUrl,
    trackView: trackView,
    trackClick: trackClick
  };

  // Reads what the server rendered on the results page: the submitted term
  // (the input's default value) and the result count line.
  function readSearchPageResult(wrap, input) {
    var countNode = wrap && wrap.querySelector('.bigsmall-search-page__count');
    if (!countNode || !input) return null;
    var text = (countNode.textContent || '').trim();
    var count = 0;
    var match = text.match(/^([\d,]+)\s+result/i);
    if (match) count = Number(match[1].replace(/,/g, ''));
    else if (!/^no results/i.test(text)) return null;
    return { submitted: String(input.defaultValue || '').trim(), count: count };
  }

  function createBridge(context) {
    var bridge = document.createElement('div');
    bridge.className = 'bs-ai-search-bridge bs-ai-search-bridge--' + context;
    bridge.setAttribute('data-bs-ai-search-bridge', '');
    bridge.hidden = true;
    bridge.innerHTML =
      '<span class="bs-ai-search-bridge__icon" aria-hidden="true">' +
        '<svg viewBox="0 0 32 32"><path d="M16 3.5l2.3 7.1 7.2 2.3-7.2 2.3-2.3 7.2-2.3-7.2-7.2-2.3 7.2-2.3L16 3.5Z"></path><path d="M24.8 19.4l1.1 3.3 3.3 1.1-3.3 1.1-1.1 3.3-1.1-3.3-3.3-1.1 3.3-1.1 1.1-3.3Z"></path></svg>' +
      '</span>' +
      '<span class="bs-ai-search-bridge__copy">' +
        '<strong></strong>' +
        '<span>Describe budget, quantity, recipient, occasion and exclusions in one sentence.</span>' +
      '</span>' +
      '<a class="bs-ai-search-bridge__link" data-bs-ai-search-link href="' + FINDER_PATH + '">Use AI Gift Finder <span aria-hidden="true">→</span></a>';
    return bridge;
  }

  var HEADINGS = {
    brief: 'This looks like a gifting brief - let the finder rank suitable options',
    few_results: 'Not finding the right match? Let the finder suggest options',
    no_results: 'No exact match? Let the finder suggest options'
  };

  function bindBridge(bridge, input, wrap, trackContext) {
    if (!bridge || bridge.dataset.bsAiBound === 'true') return;
    bridge.dataset.bsAiBound = 'true';

    var link = bridge.querySelector('[data-bs-ai-search-link]');
    var strong = bridge.querySelector('.bs-ai-search-bridge__copy strong');
    var state = { reason: '', count: '' };

    function evaluate() {
      var query = input ? input.value : '';
      if (looksLikeBrief(query)) return { reason: 'brief', count: '' };

      var served = readSearchPageResult(wrap, input);
      if (served && served.submitted && query.trim() === served.submitted && served.count <= FEW_RESULTS_MAX) {
        return { reason: served.count === 0 ? 'no_results' : 'few_results', count: served.count };
      }
      return { reason: '', count: '' };
    }

    function sync() {
      var query = input ? input.value : '';
      state = evaluate();
      bridge.hidden = !state.reason;
      bridge.classList.toggle('is-brief', state.reason === 'brief');
      if (!state.reason) return;
      if (strong) strong.textContent = HEADINGS[state.reason];
      if (link) link.href = finderUrl(query, trackContext);
      trackView(trackContext, state.reason, query, state.count);
    }

    if (link) {
      link.addEventListener('click', function () {
        trackClick(trackContext, state.reason || 'unknown', input ? input.value : '', state.count);
      });
    }

    if (input) {
      input.addEventListener('input', sync, { passive: true });
      input.addEventListener('change', sync, { passive: true });
    }
    sync();
  }

  function injectHeaderBridge() {
    document.querySelectorAll('.search-modal__content').forEach(function (modal) {
      if (modal.querySelector('.bs-ai-search-bridge--header')) return;

      var predictive = modal.querySelector('predictive-search, search-form');
      var quickLinks = modal.querySelector('.bigsmall-search-quick-links');
      var input = modal.querySelector('input[type="search"]');
      var bridge = createBridge('header');

      if (quickLinks && quickLinks.parentNode) {
        quickLinks.insertAdjacentElement('afterend', bridge);
      } else if (predictive) {
        predictive.appendChild(bridge);
      } else {
        modal.appendChild(bridge);
      }
      bindBridge(bridge, input, null, 'header_modal');
    });
  }

  function injectSearchPageBridge() {
    document.querySelectorAll('.bigsmall-search-page__form-wrap').forEach(function (wrap) {
      if (wrap.querySelector('.bs-ai-search-bridge--search-page')) return;
      var input = wrap.querySelector('input[type="search"]');
      var bridge = createBridge('search-page');
      wrap.appendChild(bridge);
      bindBridge(bridge, input, wrap, 'search_page');
    });
  }

  function ensureProductType(form) {
    if (!form) return;
    var input = form.querySelector('input[name="type"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'type';
      form.appendChild(input);
    }
    input.value = 'product';
  }

  function prepareSearchLink(link) {
    if (!link || !link.href) return;
    try {
      var url = new URL(link.href, window.location.origin);
      if (url.origin !== window.location.origin || url.pathname !== '/search') return;
      url.searchParams.set('type', 'product');
      link.href = url.toString();
    } catch (error) {
      // Ignore malformed URLs and leave Shopify's native link untouched.
    }
  }

  function prepareSearchRouting(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('form[action*="/search"]').forEach(ensureProductType);
    root.querySelectorAll('a[href*="/search?"]').forEach(prepareSearchLink);
  }

  function mount(scope) {
    injectHeaderBridge();
    injectSearchPageBridge();
    prepareSearchRouting(scope || document);
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/search') === -1) return;
    ensureProductType(form);
  }, true);

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[href*="/search?"]');
    if (link) prepareSearchLink(link);
  }, true);

  function boot() {
    mount(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    mount(event.target || document);
  });
})();
